/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProgramPeriodConfig } from '../../models/program-period-config';

export interface UpdateAdminProgramPeriodConfig$Params {
  id: string;
  body: ProgramPeriodConfig;
}

export function updateAdminProgramPeriodConfig(
  http: HttpClient,
  rootUrl: string,
  params: UpdateAdminProgramPeriodConfig$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<ProgramPeriodConfig>> {
  const rb = new RequestBuilder(rootUrl, updateAdminProgramPeriodConfig.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProgramPeriodConfig>;
    })
  );
}

updateAdminProgramPeriodConfig.PATH = '/admin/program-period-configs/{id}';
